import {
  Element,
  ElementType,
  FixtureType,
  SymbolType,
} from '@ritabygglov/core';
import { ELEMENT_FACTORIES } from './elementFactories';

export {
  createCreateChange,
  createDeleteChange,
  createUpdateChange,
} from './changes';
export { ELEMENT_FACTORIES } from './elementFactories';
export type { CreateElementInput, ElementFactory } from './elementFactories';

export const createNewElement = (
  type: ElementType,
  initialX: number,
  initialY: number,
  renderingOrder: number,
  id: string,
  userId: string,
  symbolType?: SymbolType,
  fixtureType?: FixtureType,
  options: Partial<Element> = {}
): Element | null => {
  const factory = ELEMENT_FACTORIES[type];

  if (!factory) {
    return null;
  }

  return factory.create({
    initialX,
    initialY,
    renderingOrder,
    id,
    userId,
    symbolType,
    fixtureType,
    options,
  });
};
